<section kb-card>
  <app-plain-image slot="picture"
    [section]="section.attributes.medium"
  ></app-plain-image>
  @if (section.attributes.headline) {
    <h3 slot="title" kb-heading type="bar">
      {{ section.attributes.headline }}
    </h3>
  }
  <div slot="content">
    @if (section.attributes.subline) {
      <h4 kb-heading [appEditorId]="section.editorIds?.subline">{{section.attributes.subline}}</h4>
    }
    <p kb-paragraph [appEditorId]="section.editorIds?.text">{{ section.attributes.text }}</p>
    @if (section.attributes.link) {
      <a kb-standalone-link class="more-link"
        [kbRouterOrExternalLink]="section.attributes.link.attributes.url"
        [attr.target]="section.attributes.link.attributes.target"
      >
        @if (section.attributes.link.attributes.label) {
          {{ section.attributes.link.attributes.label }}
        } @else {
          <ng-container i18n="content teaser read more link@@2827984212740060090">Read more</ng-container>
        }
      </a>
    }
  </div>
</section>
